
import { useCallback, useEffect, useState } from 'react'

import { api } from 'app/api'
import { GET_ACCOUNT_CROSS_AUTH_TOKEN, convertResult } from 'app/common/api/requests/account/tokens/cross_auth/get'


const getCrossAuthTokenSubDomain = (domain: string) => {
  if (domain === 'api') return 'dealer'
  if (domain === 'apiskud') return 'adminskud'
  return 'sys0' // for api0 and others
}

const getUrlWithCrossAuthToken = (crossAuthToken: string, personID: string) => {
  const { apiString: { value: apiBaseUrl } } = api
  const match = apiBaseUrl.match(/https?:\/\/([^.]+)\./)
  const subDomain = match ? match[1] : ''
  const crossAuthTokenSubDomain = getCrossAuthTokenSubDomain(subDomain)
  const { host } = new URL(apiBaseUrl)
  const urlWithCrossAuthToken = new URL(
    '/services/cards/add',
    `https://${crossAuthTokenSubDomain}.${host.replace(/^[^.]+\./, '')}/`,
  )
  urlWithCrossAuthToken.searchParams.set('token', crossAuthToken)
  urlWithCrossAuthToken.searchParams.set('target', personID)
  return urlWithCrossAuthToken.toString()
}

export const useBankCardUrlWithCrossAuthToken = (personID: string) => {
  const [crossAuthToken, setCrossAuthToken] = useState('')
  const [loading, setLoading] = useState(true)

  const request = useCallback(async () => {
    setLoading(true)
    const res = await api.request(GET_ACCOUNT_CROSS_AUTH_TOKEN, {
      error: 'Не удалось запустить процесс регистрации банковской карты (токен кросс-авторизации)',
      convertions: {
        convertResult,
      },
    })

    if (res) {
      setCrossAuthToken(res)
    }
    setLoading(false)
  }, [])

  useEffect(() => {
    request()
  }, [request])


  return {
    url: crossAuthToken ? getUrlWithCrossAuthToken(crossAuthToken, personID) : null,
    loading,
  }
}
